import {useMemo} from "react";
import {IComponentList} from "@tools/CustomInterfaces";
import { IPageConfig } from "@extension/config/pagesConfig";
import useLazyLoading from "@hooks/useLazyLoading";

interface Props {
    pagesConfig : IPageConfig
}

const usePlugins = (props: Props) => {
    const {pagesConfig} = props;
    const mainPath = "hydraExtension/navbar/plugins"
    const lazyLoading = useLazyLoading();

    return useMemo(() => {
        const result: IComponentList[] = [];
        const buildMap = (obj : any) => {
            Object.keys(obj).forEach(key => {
                if(obj[key].customClick)
                    result.push({name: obj[key].id, path: mainPath, component:  obj[key].customClick})
                if (obj[key] instanceof Object)
                    buildMap(obj[key])
            })
        }

        buildMap(pagesConfig.pages)
        return lazyLoading.set(result)
    }, [pagesConfig, lazyLoading])
}

export default usePlugins;
